"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusciManager = void 0;
const inversify_1 = require("inversify");
const GameState_1 = require("./GameState");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const Utils_1 = require("../Utils/Utils");
const GameConfig_1 = require("./GameConfig");
const AudioCtx_1 = require("../Common/AudioCtx");
let MusciManager = class MusciManager {
    constructor(state, resources, events, config) {
        var _a;
        const musicSource = resources.music.data;
        const music = new AudioCtx_1.AudioInstance(musicSource);
        let endPadding = Math.max(4 - musicSource.duration + (((_a = Utils_1.findex(state.map.notes, -1)) === null || _a === void 0 ? void 0 : _a.time) || 0), 0);
        music.onend.add(remove => {
            remove();
            events.Update.add((remove, dt) => {
                if (state.ended)
                    return remove();
                if (state.paused)
                    return;
                endPadding -= dt;
                if (endPadding < 0) {
                    state.on.end.emit();
                    remove();
                }
            });
        });
        const padding = Math.min(state.musicTime, -1);
        state.GetMusicTime = () => music.position;
        music.play(-padding);
        events.Update.add(remove => {
            if (state.ended)
                return remove();
            if (state.paused)
                return;
            const mt = music.position;
            state.on.musicTimeUpdate.emit({
                musicTime: mt,
                visualTime: mt + config.visualOffset / 1000,
                judgeTime: mt + config.judgeOffset / 1000,
            });
        });
        events.WindowBlur.add(() => {
            if (!state.paused)
                state.on.pause.emit();
        });
        state.on.pause.add(() => {
            music.pause();
        });
        state.on.continue.add(() => {
            music.play();
        });
        state.on.musicTimeUpdate.add((remove, mt) => {
            if (state.on.musicTimeUpdate.prevArgs)
                if (state.on.musicTimeUpdate.prevArgs[0] === mt)
                    console.warn("no use music time update:", mt);
        });
        events.End.add(() => {
            music.stop();
        });
    }
};
MusciManager = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState, SymbolClasses_1.Resources, SymbolClasses_1.GlobalEvents, GameConfig_1.GameConfig])
], MusciManager);
exports.MusciManager = MusciManager;
//# sourceMappingURL=MusicManager.js.map